import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { STACK_START_COLUMN_DIRECTION } from '../../../constants/mui-components';
import {
  recommendationSectionContainer,
  recommendationsGrid,
  recommendationCard,
  imageContainer,
  imageStyles,
} from '../styles/recommendation-section.styles';
import { getCdnUrl } from '../../../helpers';
import { recommendationsData, recommendationsDataByCountry } from '../../../constants/products/recommendations-section';
import useGetCountry from '../../../helpers/useGetCountry';

function RecommendationSection({ actualProductName }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();
  const data = recommendationsData(t);
  const country = useGetCountry();
  const allowedProducts = recommendationsDataByCountry[country] || [];
  const showRecommendations = data.recommendations.filter((recommendation) => {
    const name = recommendation.name.toLowerCase();
    return (
      allowedProducts.includes(name)
      && name !== actualProductName.toLowerCase()
    );
  });
  return (
    <Stack
      className={STACK_START_COLUMN_DIRECTION}
      sx={recommendationSectionContainer}
    >
      <Typography variant="large_2" color={theme.palette.common.black}>
        {data.title}
      </Typography>
      <Stack sx={recommendationsGrid}>
        {showRecommendations.map((recommendation) => (
          <Stack
            key={recommendation.name}
            sx={recommendationCard}
            onClick={() => navigate(recommendation.url)}
          >
            <Box sx={imageContainer}>
              <CardMedia
                component="img"
                image={getCdnUrl(recommendation.image)}
                alt={recommendation.name}
                style={imageStyles}
              />
            </Box>
            <Typography variant="medium_1" color={theme.palette.neutral.A700} fontWeight={600}>
              {recommendation.title}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

RecommendationSection.propTypes = {
  actualProductName: PropTypes.string.isRequired,
};

export default RecommendationSection;
